import axios from 'axios'
import { KeycloakHelper } from '@monorepo/infra'

export interface MediaItem {
  _id: string
  path: string
  name: string
  mimetype: string
  size: number
  tags: string[]
  email: string
  mediaType: string
  permissions: string[]
  isInUse: boolean
  usageCount: number
  usageDetails: {
    entity: string
    entityId: string
    variantIndex: number
  }[]
}

export interface MediaListResponse {
  data: MediaItem[]
  pagination: {
    page: number
    pageSize: number
    totalCount: number
    totalPages: number
  }
}

export interface MediaListParams {
  page?: number
  pageSize?: number
  mediaType?: string
  search?: string
  email?: string
  tags?: string[]
}

export const MediaHelper = {
  /**
   * Fetch list of existing media files
   */
  getMediaList: async (params: MediaListParams = {}, keycloak?: unknown): Promise<MediaListResponse> => {
    const searchParams = new URLSearchParams()
    
    if (params.page) searchParams.append('page', params.page.toString())
    if (params.pageSize) searchParams.append('pageSize', params.pageSize.toString())
    if (params.mediaType) searchParams.append('mediaType', params.mediaType)
    if (params.search) searchParams.append('search', params.search)
    if (params.email) searchParams.append('email', params.email)
    if (params.tags && params.tags.length > 0) {
      searchParams.append('tags', params.tags.join(','))
    }

    const response = await axios.get<MediaListResponse>(
      `${process.env.REACT_APP_MEDIA_URL}/list?${searchParams.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${KeycloakHelper.getToken(keycloak)}`,
        },
      }
    )

    return response.data
  },

  /**
   * Get media by ID (if needed for future use)
   */
  getMediaById: async (id: string, keycloak?: unknown): Promise<MediaItem> => {
    const response = await axios.get<MediaItem>(
      `${process.env.REACT_APP_MEDIA_URL}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${KeycloakHelper.getToken(keycloak)}`,
        },
      }
    )

    return response.data
  },

  /**
   * Delete media by ID
   */
  deleteMedia: async (id: string, keycloak?: unknown): Promise<void> => {
    await axios.delete(
      `${process.env.REACT_APP_MEDIA_URL}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${KeycloakHelper.getToken(keycloak)}`,
        },
      }
    )
  }
}
